"use client";

import { useEffect } from "react";
import _ from "lodash";

import Logger from "@/src/exceptions/Logger";
import { useDate } from "@/src/utils/functions";
import { IPage } from "@/src/store/module/page";

import Navigation from "@/src/shared/Navigation";
import Footer from "@/src/shared/Footer";
import PublicLayout from "@/src/layouts/PublicLayout";

interface ILegalProps {
    page: IPage|null;
    mobile?: boolean;
}

interface IPageParam {
    slug?: string;
}

export default function LegalView(props: ILegalProps) {
    const { mobile=false, page } = props;

    const { formatDate } = useDate()

    return (
        <PublicLayout onMobile={mobile}>
            <div className="py-10 lg:py-32 px-5 lg:px-[20rem]">
                <div className="doc-section py-10">
                    <h1 className="title">{ page?.name }</h1>

                    {/* <h3 className="date">Last Updated: September 2, 2025</h3> */}
                    <h3 className="date">Last Updated: { formatDate(page?.updated_at, "MMMM DD, YYYY hh:MM A") }</h3>

                    <div className="content" dangerouslySetInnerHTML={{ __html: page?.content ?? "" }} />
                </div>
            </div>
        </PublicLayout>
    );
}